// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-panel {
    background-color: var(--headerBackground);
    color: var(--headerColor);
    position: absolute;
    top: 0px;
    left: 0px;
    height: 36px;
    width: 100%;
    text-align: center;
    line-height: 36px;
    border-bottom: 1px solid var(--headerBorder);
}

.header-panel mat-icon {
    display: inline-block;
    vertical-align: text-top;
}

.work-panel {
    position: absolute;
    top: 37px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: var(--workPanelBackground);
}

.container {
    /* background-color: var(); */
    display: inline-table;
    width: 100%;
}

.mat-table {
    overflow: auto;
    height: 100%;
    width: 100%;
}

.mat-row {
    min-height: 40px;
    height: 43px;
}

.mat-cell {
    font-size: 13px;
}

.mat-header-row {
    top: 0;
    position: sticky;
    z-index: 1;
}

.mat-header-cell {
    font-size: 15px;
}

.mat-column-select {
    overflow: visible;
    width: 50px;
}

.mat-column-name {
    flex: 1 1 120px;
}

.mat-column-type {
    flex: 0 0 100px;
}

.mat-column-receiver {
    flex: 3 1 180px;
}
.mat-column-scheduling {
    flex: 3 1 180px;
}
.mat-column-enabled {
    flex: 0 0 60px;
}

.mat-column-create {
    width: 50px;
}

.mat-column-remove {
    width: 50px;
}

.mat-column-expand {
    width: 50px;
}

tr.detail-row {
    height: 0;
}
  
  /* .example-element-row td {
    border-bottom-width: 0;
  } */
  
.report-details {
    overflow: hidden;
    display: flex;
}

.details-description {
    min-height: 100px;
    max-height: 360px;
    margin: 5px 10px;
    padding-left: 40px;
    width: 100%;
    overflow: auto;
}

.report-detail div {
    min-width: 600px;
    display: inline-block;
}

td.details-container {
    background-color: var(--workPanelExpandBackground);
}`, "",{"version":3,"sources":["webpack://./src/app/reports/report-list/report-list.component.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;IACzC,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,UAAU;IACV,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,MAAM;IACN,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;EAEE;;KAEG;;AAEL;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,kDAAkD;AACtD","sourcesContent":[".header-panel {\n    background-color: var(--headerBackground);\n    color: var(--headerColor);\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    height: 36px;\n    width: 100%;\n    text-align: center;\n    line-height: 36px;\n    border-bottom: 1px solid var(--headerBorder);\n}\n\n.header-panel mat-icon {\n    display: inline-block;\n    vertical-align: text-top;\n}\n\n.work-panel {\n    position: absolute;\n    top: 37px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    background-color: var(--workPanelBackground);\n}\n\n.container {\n    /* background-color: var(); */\n    display: inline-table;\n    width: 100%;\n}\n\n.mat-table {\n    overflow: auto;\n    height: 100%;\n    width: 100%;\n}\n\n.mat-row {\n    min-height: 40px;\n    height: 43px;\n}\n\n.mat-cell {\n    font-size: 13px;\n}\n\n.mat-header-row {\n    top: 0;\n    position: sticky;\n    z-index: 1;\n}\n\n.mat-header-cell {\n    font-size: 15px;\n}\n\n.mat-column-select {\n    overflow: visible;\n    width: 50px;\n}\n\n.mat-column-name {\n    flex: 1 1 120px;\n}\n\n.mat-column-type {\n    flex: 0 0 100px;\n}\n\n.mat-column-receiver {\n    flex: 3 1 180px;\n}\n.mat-column-scheduling {\n    flex: 3 1 180px;\n}\n.mat-column-enabled {\n    flex: 0 0 60px;\n}\n\n.mat-column-create {\n    width: 50px;\n}\n\n.mat-column-remove {\n    width: 50px;\n}\n\n.mat-column-expand {\n    width: 50px;\n}\n\ntr.detail-row {\n    height: 0;\n}\n  \n  /* .example-element-row td {\n    border-bottom-width: 0;\n  } */\n  \n.report-details {\n    overflow: hidden;\n    display: flex;\n}\n\n.details-description {\n    min-height: 100px;\n    max-height: 360px;\n    margin: 5px 10px;\n    padding-left: 40px;\n    width: 100%;\n    overflow: auto;\n}\n\n.report-detail div {\n    min-width: 600px;\n    display: inline-block;\n}\n\ntd.details-container {\n    background-color: var(--workPanelExpandBackground);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
